
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("embim"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("embim", function(module, exports) {

let $a73be1b99b45ebb2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a73be1b99b45ebb2$var$load("h3ABO"),
    $a73be1b99b45ebb2$var$load("fTLUk"),
    $a73be1b99b45ebb2$var$load("djHM5"),
    $a73be1b99b45ebb2$var$load("eJQji"),
    $a73be1b99b45ebb2$var$load("2YffH"),
    $a73be1b99b45ebb2$var$load("2VmDq"),
    $a73be1b99b45ebb2$var$load("6mHrv"),
    $a73be1b99b45ebb2$var$load("awWN9"),
    $a73be1b99b45ebb2$var$load("9CYct"),
    $a73be1b99b45ebb2$var$load("9QUT8"),
    $a73be1b99b45ebb2$var$load("5zRul"),
    $a73be1b99b45ebb2$var$load("hZtKG"),
    $a73be1b99b45ebb2$var$load("dkqvW"),
    $a73be1b99b45ebb2$var$load("lVO3w"),
    $a73be1b99b45ebb2$var$load("hyzoX"),
    $a73be1b99b45ebb2$var$load("h9Ed7"),
    $a73be1b99b45ebb2$var$load("eBRUf"),
    $a73be1b99b45ebb2$var$load("kbRvk"),
    $a73be1b99b45ebb2$var$load("tKhaz"),
    $a73be1b99b45ebb2$var$load("9Vh0G"),
    $a73be1b99b45ebb2$var$load("hBIgN"),
    $a73be1b99b45ebb2$var$load("cD6Zr"),
    $a73be1b99b45ebb2$var$load("9wzNh"),
    $a73be1b99b45ebb2$var$load("8YSo7"),
    $a73be1b99b45ebb2$var$load("3Zfzp"),
    $a73be1b99b45ebb2$var$load("9ldRJ"),
    $a73be1b99b45ebb2$var$load("50ame"),
    $a73be1b99b45ebb2$var$load("cANzj"),
    $a73be1b99b45ebb2$var$load("57vQM"),
    $a73be1b99b45ebb2$var$load("ebWFc"),
    $a73be1b99b45ebb2$var$load("6iz6l"),
    $a73be1b99b45ebb2$var$load("4SCW2"),
    $a73be1b99b45ebb2$var$load("8bXcu"),
    $a73be1b99b45ebb2$var$load("1YiFu"),
    $a73be1b99b45ebb2$var$load("hv4mn"),
    $a73be1b99b45ebb2$var$load("Wowvf"),
    $a73be1b99b45ebb2$var$load("dek7I"),
    $a73be1b99b45ebb2$var$load("3SmkN"),
    $a73be1b99b45ebb2$var$load("dYtBN"),
    $a73be1b99b45ebb2$var$load("kNV5Y"),
    $a73be1b99b45ebb2$var$load("6wr18"),
    $a73be1b99b45ebb2$var$load("kjZZD"),
    $a73be1b99b45ebb2$var$load("jytCl"),
    $a73be1b99b45ebb2$var$load("iGhIB"),
    $a73be1b99b45ebb2$var$load("3JSgG"),
    $a73be1b99b45ebb2$var$load("37ldp"),
    $a73be1b99b45ebb2$var$load("ffEVr"),
    $a73be1b99b45ebb2$var$load("dRpV3"),
    $a73be1b99b45ebb2$var$load("28arV"),
    $a73be1b99b45ebb2$var$load("hhss7"),
    $a73be1b99b45ebb2$var$load("jYUNl"),
    $a73be1b99b45ebb2$var$load("foy8I"),
    $a73be1b99b45ebb2$var$load("jY21r"),
    $a73be1b99b45ebb2$var$load("dP7ao"),
    $a73be1b99b45ebb2$var$load("hogcU"),
    $a73be1b99b45ebb2$var$load("i8eeg"),
    $a73be1b99b45ebb2$var$load("iFdoJ"),
    $a73be1b99b45ebb2$var$load("7EorR"),
    $a73be1b99b45ebb2$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.f291fdd6.js.map
